const Reducer = (state, action) => {
	switch (action.type) {
		case "SET_RECEIPT_REFERENCE":
			return {
				...state,
				receiptReference: action.receiptReference,
				receiptFileName: action.receiptFileName,
			}

		case "SET_ORDER_ENTRY":
			return {
				...state,
				[action.key]: action.value,
			}
		case "RESET":
			return {
				salutation: 4,
				firstname: "",
				surname: "",
				email: "",
				terms: "",
				accountHolder: "",
				purchaseDate: "",
				purchaseAmount: "",
				receiptReference: null,
				receiptFileName: null,
				question1: "",
				question2: "",
				question3: "",
				question4: "",
				question5: "",
				question6: "",
				question7: "",
				iban: "",
				bic: "",
				product: "",
				age: ""
			}
		default:
			return state
	}
}

export default Reducer
